import React from 'react'
import { useDispatch } from 'react-redux'

import { modelActions } from './actions'

// fetch model data on mount
export const useModel = (endpoint, params = {}) => {
  const dispatch = useDispatch()

  React.useEffect(() => {
    dispatch(modelActions(endpoint).fetchStart(params))
  }, [dispatch])
}

// fetch model data on mount
export const useItem = (endpoint, pk) => {
  const dispatch = useDispatch()

  React.useEffect(() => {
    dispatch(modelActions(endpoint).fetchStart({ pk }))
  }, [pk, dispatch]) // eslint-disable-line react-hooks/exhaustive-deps
}
